import React from 'react';
import { Icon, CaretRight } from '@phosphor-icons/react';

import { Button, ButtonLink } from '../../../../components/general';

interface Props {
  Icon: Icon;
  label: string;
  url?: string;
  onClick?: () => void;
  isNewTab?: boolean;
  ExtraIcon?: Icon;
}

const SideNavSubBtn: React.FC<Props> = (props) => {
  const { Icon, label, url, onClick, isNewTab, ExtraIcon } = props;

  const content = (
    <React.Fragment>
      <div className="flex gap-2 items-center">
        <div className="text-[1.1rem] leading-none">
          <Icon />
        </div>

        <div>{label}</div>
      </div>

      <div className="text-[1.1rem] leading-none">
        {ExtraIcon ? <ExtraIcon /> : <CaretRight />}
      </div>
    </React.Fragment>
  );

  const buttonProps = {
    onClick,
    variant: 'primary-thin' as const,
    colour: 'transparent-grey' as const,
    className: 'w-full justify-between gap-2 text-black',
  };

  if (url)
    return (
      <ButtonLink
        {...buttonProps}
        to={url}
        target={isNewTab ? '_blank' : undefined}
      >
        {content}
      </ButtonLink>
    );

  return <Button {...buttonProps}>{content}</Button>;
};

export default SideNavSubBtn;
